import React from "react";
import { connect } from "react-redux";

import MaterialsWizardMain from "./materialsWizardMain";
import MaterialsWizardHistoryListener from "./materialsWizardHistoryListener";


const MaterialsWizardBody = () => {

  // const wizardTimeoutId = useRef();

  // const [additionalFeaturesLoading, setAdditionalFeaturesLoading] = useState(false);

  // const updateLocationLogic = () => {
  //   clearTimeout(wizardTimeoutId.current);
  //   wizardTimeoutId.current = setTimeout(lookHistoryListener, 0);
  // };

  return (
    <MaterialsWizardHistoryListener>
      <MaterialsWizardMain/>
    </MaterialsWizardHistoryListener>
  )

};

const mapStateToProps = (store) => {
  const {selectionFeatureInfo} = store.selectionState;
  const {filterGroups} = store.filterState;

  return {
    selectionFeatureInfo,
    filterGroups,
  };
};

export default connect(mapStateToProps)(MaterialsWizardBody)
